import React, { PureComponent } from 'react';
import {
  branch,
  compose,
  withProps,
  withHandlers,
} from 'recompose';
import PropTypes from 'prop-types';

import _ from 'lodash';

import Auth from '../../Auth'
import { HTMLTrans } from '../../Common/Translations';
import { willShowModal } from '../../Common/Modal/Modal'
import { connectUserHeaderinfo } from '../../Auth/WithUserHeaderInfo'

const withModal = willShowModal({ size: 'md' });

const withOnActivateVoucherHandler = withHandlers({
  onActivateVoucherHandler: ({ onAuthenticated }) => () => {
    onAuthenticated();
  },
});

export const hasLoginModal = (Comp) => {
  const Modal = withModal(Comp);

  return ({ onActivateVoucherHandler }) =>
    (
      <Modal>
        {closeModal => (
          <Auth
            closeModal={closeModal}
            onTokenUpdate={onActivateVoucherHandler}
          />
        )}
      </Modal>
    );
};

const ActivateButton = (props) => {
  const { onClick } = props;
  
  return (
    <button
      className='btn btn-secondary btn-block'
      id ='activateButton'
      onClick={onClick}
    >
      <HTMLTrans id="account.voucher_activatebutton">Activate</HTMLTrans>
    </button>
  );
}

const isNotLoggedIn = ({ isLoggedIn }) => !isLoggedIn;

const withLoginModalIfUnauthenticated = compose(
  connectUserHeaderinfo,
  withProps(({ userHeaderInfo: { isLoggedIn } }) => ({ isLoggedIn })),
  withOnActivateVoucherHandler,
  branch(
    isNotLoggedIn,
    hasLoginModal,
  ),
);

export const undecorated = ActivateButton;

export default withLoginModalIfUnauthenticated(ActivateButton);



// WEBPACK FOOTER //
// ./src/Account/Voucher/ActivateButton.js